const trophyFactory = ({
  name,
  from,
  to,
}: {
  name: string;
  from: string;
  to: string;
}) =>
  function Trophy() {
    const fillId = `${name}paint0_linear_3533_38699`;
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_3533_38699)">
          <path
            d="M23.8677 4.7854C23.7426 4.32666 23.3256 3.99303 22.8668 3.99303H18.6547C18.6964 3.49258 18.6964 3.03384 18.6547 2.6168C18.6547 1.90783 18.0709 1.32397 17.3202 1.32397H6.68569C5.93502 1.32397 5.35116 1.90783 5.35116 2.6168C5.30946 3.03384 5.30946 3.49258 5.35116 3.99303H1.13906C0.680322 3.99303 0.263282 4.32666 0.13817 4.7854C0.13817 4.91051 -0.654204 8.33024 1.5561 11.5831C3.09915 13.9186 5.7265 15.545 9.35474 16.5042C10.1471 16.7127 10.6476 17.4217 10.6476 18.2141C10.6893 19.215 9.85519 20.0073 8.85429 20.0073H8.68748C7.56147 20.0073 6.68569 20.9248 6.68569 22.0091C6.68569 22.3845 6.97762 22.6764 7.31125 22.6764H16.6112C16.9866 22.6764 17.2368 22.3845 17.2368 22.0091C17.2368 20.9248 16.3193 20.0073 15.235 20.0073H15.0265C14.0256 20.0073 13.2332 19.215 13.2332 18.2141C13.2332 17.4217 13.7754 16.7127 14.526 16.5042C18.1543 15.545 20.7816 13.9186 22.3664 11.5831C24.6601 8.33024 23.8677 4.91051 23.8677 4.7854ZM3.22426 10.4988C2.05655 8.78898 1.97314 6.99571 2.01485 5.99481H5.35116C5.60139 8.49705 6.22695 11.4997 7.76999 13.9186C5.7265 13.0845 4.18345 11.9585 3.22426 10.4988ZM20.7816 10.4988C19.8224 11.9585 18.2794 13.0845 16.2359 13.9186C17.7789 11.4997 18.4045 8.49705 18.6547 5.99481H21.991C22.0327 6.99571 21.9493 8.78898 20.7816 10.4988Z"
            fill={`url(#${fillId})`}
          />
        </g>
        <defs>
          <linearGradient
            id={fillId}
            x1="12"
            y1="1.32397"
            x2="12"
            y2="22.6764"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={from} />
            <stop offset="1" stopColor={to} />
          </linearGradient>
          <clipPath id="clip0_3533_38699">
            <rect
              width="24"
              height="24"
              fill="white"
              transform="translate(0 0.000244141)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };

export const Gold = trophyFactory({
  name: 'Gold',
  from: '#CAA860',
  to: '#9C6125',
});
export const Silver = trophyFactory({
  name: 'Silver',
  from: '#AEB6B6',
  to: '#6A6F70',
});
export const Bronze = trophyFactory({
  name: 'Bronze',
  from: '#BD7E4E',
  to: '#9B5923',
});
